// Matches an actual HTML element tag (`<p>`, `</div>`, `<br/>`, `<a href=...>`)
// by requiring a known tag name, so that real markup isn't silently HTML-escaped
// downstream, without misclassifying plaintext that merely contains angle
// brackets such as `<john@example.com>`, `<n/a>` or `<https://example.com>`.
const HTML_TAG_RE = /<\/?(html|body|p|div|span|br|a|table|tr|td|th|thead|tbody|ul|ol|li|h[1-6]|strong|em|b|i|u|hr|img|blockquote|pre|code)(\s[^>]*)?\/?>/i;
export const looksLikeHtml = (value) => HTML_TAG_RE.test(value);
export const escapeHtml = (value) => value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
export const plaintextToHtml = (value) => {
    if (looksLikeHtml(value)) {
        return value;
    }
    const paragraphs = escapeHtml(value)
        .split(/\n{2,}/)
        .map((paragraph) => paragraph.trim())
        .filter(Boolean);
    if (paragraphs.length === 0) {
        return '';
    }
    return paragraphs
        .map((paragraph) => `<p>${paragraph.replace(/\n/g, '<br>')}</p>`)
        .join('');
};
export const htmlToPlaintext = (html) => {
    html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
    html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
    html = html.replace(/<\/div>/gi, '\n');
    html = html.replace(/<\/li>/gi, '\n');
    html = html.replace(/<li>/gi, '  *  ');
    html = html.replace(/<\/ul>/gi, '\n');
    html = html.replace(/<\/p>/gi, '\n');
    html = html.replace(/<br\s*[/]?>/gi, '\n');
    html = html.replace(/<[^>]+>/gi, '');
    html = html.replace(/&lt;/gi, '<');
    html = html.replace(/&gt;/gi, '>');
    html = html.replace(/&amp;/gi, '&');
    html = html.replace(/&apos;/gi, "'");
    html = html.replace(/&#39;/g, "'");
    html = html.replace(/&quot;/gi, '"');
    html = html.replace(/&nbsp;/gi, '\u00A0');
    return html;
};
export const isBlankHtml = (html) => htmlToPlaintext(html).trim() === '';
//# sourceMappingURL=html.js.map